<template>
  <v-card
    class="ma-0 pa-3"
    height="342"
  >
      <v-container
        class="pa-0 d-flex justify-space-between align-center mb-5"
      >
        <v-card-text class="text-body-2 pa-0">{{ $t('debtror-creditor-chart') }}</v-card-text>
        <!-- <v-select
          :items="items"
          label="یک هفته گذشته"
          dense
          outlined
          append-icon="mdi-chevron-down"
        >
        </v-select> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="secondary"
              outlined
              v-bind="attrs"
              v-on="on"
              custom
            >
              <svg width="17" height="17" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 8L3.5 5.5L4.2 4.775L5.5 6.075V2H6.5V6.075L7.8 4.775L8.5 5.5L6 8ZM3 10C2.725 10 2.48967 9.90217 2.294 9.7065C2.09833 9.51083 2.00033 9.27533 2 9V7.5H3V9H9V7.5H10V9C10 9.275 9.90217 9.5105 9.7065 9.7065C9.51083 9.9025 9.27533 10.0003 9 10H3Z" fill="#030303"/>
              </svg>
            </v-btn>
          </template>
          <v-list v-if="mainData != null && debtorsCount != null && debtorsCount != undefined && $store.getters.getpermission && $store.getters.getpermission.includes('overview')">
            <v-list-item @click="exportChart('png')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('PNG-image') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportChart('pdf')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('PDF-file') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportChart('excel')">
              <v-list-item-title>
                <v-card-text class="pa-0 text-body-2">{{ $t('EXCEL-file') }}</v-card-text>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
      <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
        <v-container class="d-flex justify-center align-center pa-0">
        <apexchart
          v-if="mainData != null && debtorsCount != null && debtorsCount != undefined"
          type="donut"
          :options="donutChartOptions"
          :series="donutChartSeries"
          width="250"
          ref="chartComponent"
        />
        <div
          v-if="mainData == null && !loading"
          style="margin-top: 33px;"
        >
          <div class="d-flex justify-center align-center">
            <img src="@/assets/dashboard/no-data(2).png" style="width: 120px;" />
          </div>
          <div class="d-flex justify-center align-center mt-5">
            <v-card-text class="pa-0 text-caption">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </div>
        </div>
        <v-progress-circular
          v-if="loading"
          :width="3"
          color="blue"
          indeterminate
        />
        </v-container>
        <v-container 
          class="pa-0 d-flex justify-space-between align-center mt-4" 
          v-if="mainData != null && debtorsCount != null && debtorsCount != undefined"
        >
          <div>
            <div
              v-for="(label, index) in donutChartOptions.labels"
              :key="index"
              class="mb-1"
            >
              <v-card-text
                class="pa-0 text-body-2"
                :style="{ color: donutChartOptions.colors[index] }"
              >
              {{ label }}
              </v-card-text>
            </div>
          </div>
          <div class="text-left" v-if="totals != null && totals != undefined">
            <div
              v-for="(total, index) in totals"
              :key="index"
              class="mb-1"
            >
            <v-card-text
              class="pa-0 text-body-2 d-flex align-center justify-end gap-1"
              :style="{ color: donutChartOptions.colors[index] }"
            >
              <span style="direction: ltr;">{{ $numberFormat(total) }}</span>
              <span>{{ $store.state.currency.name }}</span>
            </v-card-text>
            </div>
          </div>
        </v-container>
      </div>
      <div v-else>
        <div
          style="margin-top: 33px;"
        >
          <div class="d-flex justify-center align-center">
            <img src="@/assets/dashboard/not-access(3).png" style="width: 120px;" />
          </div>
          <div class="d-flex justify-center align-center mt-5">
            <v-card-text class="pa-0 text-caption text-center">
              {{ $t("you don't have access to this information") }}
            </v-card-text>
          </div>
        </div>
      </div>
  </v-card>
</template>

<script>
import jsPDF from "jspdf" // PDF export
import * as XLSX from "xlsx" // Excel export

export default {
  data () {
    return {
      debtorsCount: null,
      creditorsCount: null,
      totals: [],
      loading: false,
      mainData: null,
      donutChartOptions: {
        chart: {
          id: 'donut-chart',
          toolbar: {
            show: false,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: '<p>d</p>',
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            },
            export: {
              scale: undefined,
              width: undefined,
              csv: {
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                categoryFormatter (x) {
                  return new Date(x).toDateString()
                },
                valueFormatter (y) {
                  return y
                }
              },
              svg: {
                filename: undefined
              },
              png: {
                filename: undefined
              }
            },
            autoSelected: 'zoom'
          },
          fontFamily: 'IRANSans'
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              width: '40%'
            }
          }
        },
        labels: [this.$t('debtor'), this.$t('creditor')],
        colors: ['#ff5252', '#4caf50'], // Colors for slices (Red, Green, Blue)
        legend: {
          show: false,
          labels: {
            useSeriesColors: true // Match legend colors to chart colors
          },
          fontSize: '11rem',
          fontFamily: 'inherit'
        },
        fill: {
          type: 'solid' // Ensures solid colors are used
        }
      },
      // Data for the donut chart (market share)
      donutChartSeries: []
    }
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$axios.get(this.$endpoint + 'customerreport', {
        params: {
          select: 'customersBalanceStatus'
        }
      })
        .then(r => {
          this.loading = false
          this.mainData = r.data
          this.debtorsCount = r.data.debtorsCount
          this.creditorsCount = r.data.creditorsCount
          // Calculate the total count (debtors + creditors)
          this.totalCount = this.debtorsCount + this.creditorsCount

          // Calculate percentages for each group
          const debtorsPercent = (this.debtorsCount / this.totalCount) * 100
          const creditorsPercent = (this.creditorsCount / this.totalCount) * 100

          // Now update the donut chart series with percentages
          this.donutChartSeries = [debtorsPercent, creditorsPercent]

          this.totals = [r.data.debtorsTotal, r.data.creditorsTotal]
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
        })
    },
    async exportChart(format) {
      const chartRef = this.$refs.chartComponent?.chart;
      if (!chartRef) {
        console.error("Chart instance not available.");
        return;
      }

      try {
        if (format === "png" || format === "svg") {
          const { imgURI } = await chartRef.dataURI(); // Get image data
          this.downloadImage(imgURI, `chart-export.${format}`);
        } else if (format === "pdf") {
          await this.exportToPDF();
        } else if (format === "excel") {
          this.exportToExcel();
        }
      } catch (error) {
        console.error("Export failed:", error);
      }
    },

    // 📌 Download PNG / SVG
    downloadImage(uri, filename) {
      const link = document.createElement("a");
      link.href = uri;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 📌 Export to PDF (using jsPDF)
    async exportToPDF() {
      const chartRef = this.$refs.chartComponent?.chart;
      if (!chartRef) return;

      const { imgURI } = await chartRef.dataURI(); // Get chart as image
      const pdf = new jsPDF(); // Create a new PDF
      pdf.addImage(imgURI, "PNG", 15, 40, 180, 120); // Add image to PDF
      pdf.save("chart-export.pdf"); // Save PDF
    },

    // 📌 Export to Excel (using XLSX)
    exportToExcel() {
      if (!this.totals || this.totals.length < 2) {
        console.error("Total amounts are missing or incomplete.");
        return;
      }

      const worksheet = XLSX.utils.aoa_to_sheet([
        [this.$t('amount-list'), this.$t('value')],
        [this.$t('debt-amount'), this.formatNumber(this.totals[0])],
        [this.$t('credit-amount'), this.formatNumber(this.totals[1])],
      ]);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");
      XLSX.writeFile(workbook, "chart-export.xlsx");
    },

    formatNumber(amount) {
      return amount.toLocaleString('en-US', { minimumFractionDigits: 2 });
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0 4px 0 0 !important;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-label.v-label {
  font-size: 11px !important;
}
::v-deep .v-icon.v-icon {
  font-size: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
/* ::v-deep .apexcharts-canvas,
::v-deep .apexcharts-canvas .apexcharts-svg,
::v-deep .apexcharts-canvas .apexcharts-svg foreignObject {
  width: 100% !important;
} */
/* ::v-deep .apexcharts-legend {
  padding: 0!important;
  top: 40px !important;
  right: 0 !important;
  gap: .3rem;
} */
/* ::v-deep .apexcharts-legend-series {
  margin: 0 !important;
  display: flex;
  align-items: center;
  gap: .2rem;
} */
/* ::v-deep .apexcharts-legend-series .apexcharts-legend-marker {
  margin: 0 !important;
}
::v-deep .apexcharts-inner {
  transform: none !important;
} */
/* ::v-deep .apexcharts-toolbar {
  top: -41px !important;
  right: 190px !important;
}
::v-deep .apexcharts-menu-icon::before {
  content: "\F1DA";
  font-size: 18px;
  display: block;
} */
</style>
